import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import usePageMeta from '@/hooks/usePageMeta';

const allProjects = [
  {
    img: '/images/ref1.jpg',
    alt: 'Sondermaschinen & Anlagen – gowiTEC',
    category: 'Sondermaschinen & Anlagen',
    title: 'Sondermaschinen & Anlagen',
    description: 'Individuelle Montageanlagen, automatisierte Fertigungssysteme und Sondermaschinen nach Kundenanforderung.',
  },
  {
    img: '/images/ref2.jpg',
    alt: 'Automatisierung & Handling – gowiTEC',
    category: 'Automatisierung & Handling',
    title: 'Automatisierung & Handling',
    description: 'Fördertechnik, Transfersysteme, pneumatische und elektrische Systeme sowie automatisierte Abläufe.',
  },
  {
    img: '/images/ref3.jpg',
    alt: 'Steuerungstechnik & SPS – gowiTEC',
    category: 'Steuerungstechnik & SPS',
    title: 'Steuerungstechnik & SPS',
    description: 'Schaltschrankbau, SPS-Steuerungen, Anlagenintegration, Inbetriebnahme und Optimierung.',
  },
  {
    img: '/images/ref4.jpg',
    alt: 'Projektumsetzung – gowiTEC',
    category: 'Projektumsetzung',
    title: 'Projektumsetzung',
    description: 'Echte Bilder aus realisierten Anlagen und technischen Anwendungen – von der Idee bis zur Inbetriebnahme.',
  },
  {
    img: '/images/ref5.jpg',
    alt: 'Maschinenbau Detail – gowiTEC',
    category: 'Sondermaschinen & Anlagen',
    title: 'Maschinenbau Detail',
    description: 'Detailansicht einer realisierten Sondermaschine – präzise Mechanik und durchdachte Konstruktion.',
  },
  {
    img: '/images/anlage2.jpg',
    alt: 'Automatisierte Anlage – gowiTEC',
    category: 'Automatisierung & Handling',
    title: 'Automatisierte Anlage',
    description: 'Vollautomatische Anlage für Montage, Prüfung und Produktion – individuell auf den Kundenprozess abgestimmt.',
  },
  {
    img: '/images/panel.jpg',
    alt: 'Bedienpanel HMI – gowiTEC',
    category: 'Steuerungstechnik & SPS',
    title: 'HMI-Bedienpanel',
    description: 'Modernes Bedienpanel mit HMI-Visualisierung für eine vollautomatische Produktionsanlage.',
  },
  {
    img: '/images/schrank1.jpg',
    alt: 'Beckhoff SPS Schaltschrank – gowiTEC',
    category: 'Steuerungstechnik & SPS',
    title: 'Beckhoff SPS-Schaltschrank',
    description: 'Professioneller Schaltschrankbau mit Beckhoff TwinCAT SPS – sauber verdrahtet und normgerecht ausgeführt.',
  },
  {
    img: '/images/detail1.jpg',
    alt: 'Maschinendetail – gowiTEC',
    category: 'Sondermaschinen & Anlagen',
    title: 'Maschinendetail',
    description: 'Detailaufnahme einer Sondermaschine – hochwertige Verarbeitung und präzise Mechanik.',
  },
  {
    img: '/images/sps1.jpg',
    alt: 'SPS Steuerungstechnik – gowiTEC',
    category: 'Steuerungstechnik & SPS',
    title: 'SPS-Steuerung',
    description: 'SPS-Steuerung und Verdrahtung für eine komplexe Automatisierungsanlage.',
  },
  {
    img: '/images/sps2.jpg',
    alt: 'Steuerungstechnik Schaltschrank – gowiTEC',
    category: 'Steuerungstechnik & SPS',
    title: 'Steuerungsschrank',
    description: 'Schaltschrankbau und Systemintegration – zuverlässige Steuerungstechnik für industrielle Anwendungen.',
  },
  {
    img: '/images/hero-start.jpg',
    alt: 'Automatisierte Anlage – gowiTEC',
    category: 'Automatisierung & Handling',
    title: 'Produktionsanlage',
    description: 'Sondermaschine und individuelle Anlage für Montage, Prüfung und Produktion.',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=industrial%20laser%20cutting%20machine%20in%20action%20with%20bright%20laser%20beam%20cutting%20through%20metal%20sheet%20in%20a%20modern%20manufacturing%20facility%20with%20sparks%20flying%20and%20precision%20engineering%20equipment&width=800&height=540&seq=lasertec-ref-01&orientation=landscape',
    alt: 'Laserschneiden Metall – gowiTEC',
    category: 'Lasertechnik',
    title: 'Laserschneiden – Präzisionsbauteile',
    description: 'Hochpräzises Laserschneiden von Metallbauteilen für die Automobilindustrie – engste Toleranzen, saubere Schnittkanten, vollautomatisch in die Fertigungslinie integriert.',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=laser%20marking%20engraving%20machine%20marking%20serial%20numbers%20and%20logos%20on%20metal%20parts%20in%20industrial%20production%20environment%20with%20precise%20laser%20beam%20and%20professional%20equipment&width=800&height=540&seq=lasertec-ref-02&orientation=landscape',
    alt: 'Lasermarkierung Seriennummern – gowiTEC',
    category: 'Lasertechnik',
    title: 'Lasermarkierung & Rückverfolgbarkeit',
    description: 'Dauerhafte Lasermarkierung von Seriennummern, DataMatrix-Codes und Logos auf Metallteilen – fälschungssicher, maschinenlesbar und normgerecht nach GS1-Standard.',
  },
];

const categories = ['Alle', 'Sondermaschinen & Anlagen', 'Automatisierung & Handling', 'Steuerungstechnik & SPS', 'Projektumsetzung', 'Lasertechnik'];

const stats = [
  { value: '500+', label: 'Projekte realisiert' },
  { value: '30+', label: 'Jahre Erfahrung' },
  { value: '7', label: 'Leistungsbereiche' },
  { value: '100%', label: 'Individuelle Lösungen' },
];

const ReferenzenPage = () => {
  const [activeCategory, setActiveCategory] = useState('Alle');
  const [lightbox, setLightbox] = useState<{ img: string; alt: string; title: string; description: string } | null>(null);

  usePageMeta({
    title: 'Referenzen – Realisierte Projekte in Maschinenbau & Automation | gowiTEC',
    description: 'Über 500 realisierte Projekte: Sondermaschinen, Automatisierungsanlagen und Steuerungstechnik von gowiTEC Reichshof. Einblicke in echte Kundenprojekte.',
    keywords: 'Referenzen Maschinenbau, Automatisierungsprojekte, Sondermaschinen Beispiele, SPS-Projekte, gowiTEC Referenzen',
    canonical: 'https://gowitec.de/referenzen',
  });

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setLightbox(null);
    };
    if (lightbox) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [lightbox]);

  const filtered = activeCategory === 'Alle'
    ? allProjects
    : allProjects.filter((p) => p.category === activeCategory);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-24 bg-[#0f1f4a] overflow-hidden min-h-[440px] flex items-center">
          <div className="absolute inset-0">
            <img
              src="/images/oben1.jpg"
              alt="gowiTEC Referenzen"
              className="w-full h-full object-cover object-center"
              loading="eager"
              fetchPriority="high"
              decoding="async"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0f1f4a] via-[#0f1f4a]/90 to-[#0f1f4a]/55" />
          </div>
          <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-0.5 bg-[#DC2626]"></span>
              <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">Referenzen</span>
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-5 leading-tight max-w-2xl">
              Einblicke in unsere Projekte
            </h1>
            <p className="text-blue-200 text-base md:text-lg max-w-xl leading-relaxed">
              Die folgenden Beispiele geben einen Einblick in bereits umgesetzte Projekte aus den Bereichen Maschinenbau, Automation und Steuerungstechnik.
            </p>
          </div>
        </section>

        {/* Stats */}
        <section className="bg-[#1E3A8A] py-12">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-white text-4xl font-bold mb-1">{s.value}</div>
                  <div className="text-blue-200 text-sm">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Gallery */}
        <section className="py-20 bg-[#F8FAFC]">
          <div className="max-w-7xl mx-auto px-6 md:px-10">

            {/* Filter */}
            <div className="flex flex-wrap gap-2 mb-10">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    activeCategory === cat
                      ? 'bg-[#1E3A8A] text-white'
                      : 'bg-white border border-gray-200 text-gray-600 hover:border-[#1E3A8A] hover:text-[#1E3A8A]'
                  }`}
                >
                  {cat}
                  {cat === 'Alle' && (
                    <span className="ml-2 text-xs opacity-60">{allProjects.length}</span>
                  )}
                </button>
              ))}
            </div>

            {/* Featured – erste 2 groß */}
            {filtered.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
                {filtered.slice(0, 2).map((p) => (
                  <div
                    key={p.img + 'feat'}
                    className="group relative w-full h-[320px] rounded-xl overflow-hidden cursor-pointer bg-gray-100"
                    onClick={() => setLightbox(p)}
                  >
                    <img
                      src={p.img}
                      alt={p.alt}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                      <span className="inline-block text-[#DC2626] text-xs font-semibold tracking-widest uppercase mb-1">
                        {p.category}
                      </span>
                      <h3 className="text-white font-bold text-lg mb-1">{p.title}</h3>
                      <p className="text-white/75 text-sm leading-relaxed line-clamp-2">{p.description}</p>
                    </div>
                    <div className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <i className="ri-zoom-in-line text-white text-sm"></i>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Rest – 3-Spalten-Grid */}
            {filtered.length > 2 && (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
                {filtered.slice(2).map((p) => (
                  <div
                    key={p.img + p.category}
                    className="group bg-white rounded-xl border border-gray-100 overflow-hidden cursor-pointer hover:border-[#1E3A8A]/20 transition-all duration-300"
                    onClick={() => setLightbox(p)}
                  >
                    <div className="w-full h-52 overflow-hidden bg-gray-100">
                      <img
                        src={p.img}
                        alt={p.alt}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-5">
                      <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">{p.category}</span>
                      <h3 className="text-gray-900 font-semibold text-base mt-1 mb-2">{p.title}</h3>
                      <p className="text-gray-500 text-sm leading-relaxed line-clamp-2">{p.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Hinweis */}
            <div className="bg-white border-l-4 border-[#1E3A8A] rounded-r-xl px-6 py-5">
              <p className="text-gray-600 text-sm leading-relaxed">
                <strong className="text-gray-800">Hinweis:</strong> Viele Projekte werden kundenspezifisch umgesetzt
                und unterliegen Vertraulichkeit. Daher werden bewusst keine detaillierten Projektdaten oder
                Kundennamen veröffentlicht.
              </p>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 bg-[#1E3A8A]">
          <div className="max-w-7xl mx-auto px-6 md:px-10 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Ihr Projekt als nächstes?</h2>
            <p className="text-blue-200 text-lg mb-8 max-w-xl mx-auto">
              Kontaktieren Sie uns – wir beraten Sie kostenlos und unverbindlich zu Ihrer Automatisierungsaufgabe.
            </p>
            <Link
              to="/anfrage"
              className="inline-flex items-center gap-2 bg-[#DC2626] hover:bg-[#b91c1c] text-white font-semibold px-8 py-4 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Jetzt Projekt anfragen
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
            </Link>
          </div>
        </section>
      </main>
      <Footer />

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/88 flex items-center justify-center p-6 cursor-pointer"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-5 right-5 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
            onClick={() => setLightbox(null)}
            aria-label="Lightbox schließen"
          >
            <i className="ri-close-line text-xl" aria-hidden="true"></i>
          </button>
          <div
            className="max-w-4xl w-full flex flex-col gap-4"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={lightbox.img}
              alt={lightbox.alt}
              className="w-full max-h-[70vh] rounded-xl object-contain"
              loading="lazy"
            />
            <div className="bg-white/10 backdrop-blur-sm rounded-xl px-6 py-4">
              <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">{lightbox.category}</span>
              <h3 className="text-white font-bold text-lg mt-1 mb-1">{lightbox.title}</h3>
              <p className="text-white/70 text-sm leading-relaxed">{lightbox.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReferenzenPage;
